module.exports = __webpack_public_path__ + "img/house03.8ce286d1.jpg";